export default "__VITE_ASSET__BVbOVIlc__"